/*
 * File: WaveDecoration.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 20, 2025 at 7:07 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Constants
import { xxLargeBreakpoint } from '../../styles/constants';


/**
 * Styles
 */

export const WaveDecoration = styled.div`
	background-image: ${({ $decoration }) => `url(${$decoration})`};
	background-size: 300% 94%;
	background-position: 70% 150%;
	background-repeat: no-repeat;
	position: absolute;
	width: 100%;
	height: 100%;
	bottom: 0px;
	z-index: 1;

	@media only screen and (min-width: ${xxLargeBreakpoint}em) {
		background-size: 180% 94%;
		background-position: 60% 150%;
	}
`;
